import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectDeviceState = (state: AppState) =>
  state.deviceVct;


export const selectVctSitesList = createSelector(
  selectDeviceState,
  (state) => state.sitesList
);
export const selectVctPlantsList = createSelector(
  selectDeviceState,
  (state) => state.plantsList
);
export const selectVctInvitationsList = createSelector(
  selectDeviceState,
  (state) => state.invitationsList
);
export const selectLoadingDevicesVctList = createSelector(
  selectDeviceState,
  (state) => state.loadingDevicesVctList
);
export const selectVctLoadingInvitations = createSelector(
  selectDeviceState,
  (state) => state.loadingInvitations
);
export const selectDeviceVctSharing = createSelector(
  selectDeviceState,
  (state) => state.deviceVctSharing
);
export const selectDeviceVctShared = createSelector(
  selectDeviceState,
  (state) => state.deviceVctShared
);
export const selectDeviceVctDeleting = createSelector(
  selectDeviceState,
  (state) => state.deviceVctDeleting
);
export const selectDeviceVctDeleted = createSelector(
  selectDeviceState,
  (state) => state.deviceVctDeleted
);
export const selectDeviceVctPlantEditing = createSelector(
  selectDeviceState,
  (state) => state.deviceVctPlantEditing
);
export const selectDeviceVctPlantEdited = createSelector(
  selectDeviceState,
  (state) => state.deviceVctPlantEdited
);
export const selectDeviceVctModuleEditing = createSelector(
  selectDeviceState,
  (state) => state.deviceVctModuleEditing
);
export const selectDeviceVctModuleEdited = createSelector(
  selectDeviceState,
  (state) => state.deviceVctModuleEdited
);
export const selectDeviceVctFeatureEditing = createSelector(
  selectDeviceState,
  (state) => state.deviceVctFeatureEditing
);
export const selectDeviceVctFeatureEdited = createSelector(
  selectDeviceState,
  (state) => state.deviceVctFeatureEdited
);
export const selectDeviceVctAuxEdited = createSelector(
  selectDeviceState,
  (state) => state.deviceVctAuxEdited
);
export const selectEditSystem = createSelector(
  selectDeviceState,
  (state) => state.editSystem
);
export const selectDeviceVctInvitationAppReseted = createSelector(
  selectDeviceState,
  (state) => state.deviceVctInvitationAppReseted
);
export const selectDeviceVctMassiveSharing = createSelector(
  selectDeviceState,
  (state) => state.deviceVctMassiveSharing
);
export const selectDeviceVctMassiveShared = createSelector(
  selectDeviceState,
  (state) => state.deviceVctMassiveShared
);
export const selectLoadingSitesVctList = createSelector(
  selectDeviceState,
  (state) => state.loadingSitesVctList
);
